/**
 * Contact marketing page (`/contact`) — GitHub issue "Create React
 * components for static marketing pages using vite-react-ssg".
 *
 * Statically generated; no client-side data fetching or auth dependency
 * (Requirement #7) — this page intentionally links to a `mailto:` address
 * rather than rendering a form that would POST to an API, keeping it 100%
 * SSG-safe.
 */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import MarketingLayout from '@/components/marketing/MarketingLayout';
import SeoHead from '@/components/marketing/SeoHead';
import { Button } from '@/components/ui/button';

export default function ContactPage(): JSX.Element {
  const { t } = useTranslation();
  const email = t('marketing.contact.email');

  return (
    <MarketingLayout>
      <SeoHead
        title={t('marketing.contact.title')}
        description={t('marketing.contact.description')}
        path="/contact"
      />

      <section className="container mx-auto max-w-2xl px-4 py-16 text-center">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
          {t('marketing.contact.heading')}
        </h1>
        <p className="mt-4 text-xl text-muted-foreground">{t('marketing.contact.subheading')}</p>

        <p className="mt-8 text-lg">
          {t('marketing.contact.emailLabel')}{' '}
          <a href={`mailto:${email}`} className="font-medium text-primary hover:underline">
            {email}
          </a>
        </p>

        <div className="mt-8">
          <Button size="lg" asChild>
            <Link to="/getstarted">{t('marketing.contact.cta')}</Link>
          </Button>
        </div>
      </section>
    </MarketingLayout>
  );
}
